<script setup lang="ts">
import { ref } from "vue";
import { signIn } from "@/firebase";

const error = ref<string | null>(null);
const busy = ref(false);

async function go(): Promise<void> {
  busy.value = true;
  error.value = null;
  try {
    await signIn();
  } catch (err) {
    // Die Blocking-Function lehnt fremde Konten ab — die Meldung von Firebase
    // ist technisch, deshalb hier eine, die erklärt was los ist.
    const message = (err as Error).message ?? "";
    error.value = message.includes("permission-denied") || message.includes("blocked")
      ? "Dieser Zugang ist auf das STARTS-Team beschränkt."
      : message;
  } finally {
    busy.value = false;
  }
}
</script>

<template>
  <div class="grid min-h-dvh place-items-center px-6">
    <div class="card w-full max-w-sm p-8 text-center">
      <h1 class="text-[19px] font-semibold tracking-tight">STARTS Liquidität</h1>
      <p class="mt-2 text-[13px] text-ink-3">Bankkonto und MOCO in einer Zahl.</p>
      <button
        type="button" class="mt-6 w-full rounded-md bg-s1 px-4 py-2.5 text-[13px] font-medium text-white disabled:opacity-50"
        :disabled="busy" @click="go"
      >{{ busy ? "Anmeldung läuft…" : "Mit Google anmelden" }}</button>
      <p v-if="error" class="mt-4 text-[12.5px]" style="color: var(--critical)">{{ error }}</p>
    </div>
  </div>
</template>
